/**
 * Mixins ช่วยเช็คว่า scroll ถึงล่างสุดยัง ถ้าถึงแล้วให้รันฟังก์ชัน callback()
 * วิธีใช้ : ให้ mounted ฟังก์ชัน $_scrollBottomCheckerMixin_scroll พร้อมกับส่งฟังก์ชันที่ต้องการให้ทำงานผ่าน param
 */

export const scrollBottomCheckerMixin = {
  data: () => ({
    $_isLoading: false
  }),

  methods: {
    /**
     * ฟังก์ชันเช็คการเลื่อนหน้าจอไปยังด้านล่าง
     * @param {Function} callback ฟังก์ชันที่จะถูกเรียกเมื่อเลื่อนไปล่างหน้าจอ
     */
    $_scrollBottomCheckerMixin_scroll(callback) {
      window.addEventListener('scroll', async () => {
        if (this.$_isLoading) return;
        const d = document.documentElement;
        const scrolledY = window.scrollY;
        const height = window.innerHeight;
        if (scrolledY + height >= d.scrollHeight) {
          await callback();
        }
      });
    }
  }
};
